export * from './Badge';
//# sourceMappingURL=index.js.map